import { ReactNode } from "react";
import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import { useNavigate } from "react-router";
import { FinanceNavigation } from "./FinanceNavigation";
import { BUSINESS } from "../../../../constants/routes";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { usePayoutCreateRyftAccountUrl } from "../../../../hooks/api/v2/payout/usePayoutCreateRyftAccountUrl";
import { Icon } from "@sellar-io/components";
const CompleteRyftOnboardingBanner = ({ onClick }: { onClick: () => void }) => {
  return (
    <div
      onClick={onClick}
      className="group w-full max-w-[1200px] cursor-pointer border border-blue-300 bg-blue-100 md:rounded-lg"
    >
      <div className="flex justify-between gap-2 px-2 py-2 md:items-center md:px-3">
        <div className="flex items-center text-sm font-semibold text-zinc-800">
          <Icon icon="INFORMATION" className="mr-2 h-4 w-4 text-blue-800" />
          <span className="">Complete Ryft signup to receive your payouts</span>
        </div>
        <div className="flex flex-nowrap items-center text-sm font-semibold text-nowrap text-blue-800">
          <span className="group-hover:underline">Go to Ryft</span>
          <Icon icon="CHEVRON_RIGHT" className="h-4 w-4 text-blue-800" />
        </div>
      </div>
    </div>
  );
};

export const FinanceSettingsLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const navigate = useNavigate();
  const businessQuery = useSellarCurrentBusiness();
  const payoutGetRyftAccountUrlMutation = usePayoutCreateRyftAccountUrl();

  const onClick = () => {
    return payoutGetRyftAccountUrlMutation.mutate(undefined, {
      onSuccess: (data) => {
        window.open(data.url, "_blank", "noopener,noreferrer");
      },
    });
  };

  return (
    <>
      <NavigationBar
        title={"Finances"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => navigate(BUSINESS)}
      />
      <div className="mx-auto max-w-[1200px] bg-white md:bg-transparent md:p-2">
        {businessQuery.business?.Supplier?.ryftAccountStatus !==
          "completed" && <CompleteRyftOnboardingBanner onClick={onClick} />}
        <FinanceNavigation />
        {children}
      </div>
    </>
  );
};
